<template>
    <b-modal
        id="add-user-modal"
        ref="add-user-modal"
        size="lg"
        :title="$t('project.add_participants')"
        modal-class="apprentice-default-modal group-modal-admin"
        :ok-title="$t('common.close')"
        ok-only
        @show="load">
        <design-2021-apprentice-data-table
            class="group-admin-users-table"
            :items="items"
            :fields="fields">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-account"
                    v-b-modal="'school-account-add-user'"
                    variant="primary">
                    {{ $t('project.create_new_user') }}
                </b-button>
                <design-2021-school-accounts-add-account-modal-component
                    @user-created="load()"></design-2021-school-accounts-add-account-modal-component>
            </template>

            <template v-slot:cell(type)="data">
                {{ data.item.type === 'student' ? $t('project.student') : $t('project.teacher') }}
            </template>

            <template v-slot:cell(action)="data">
                <b-button
                    class="btn-add btn-add-user"
                    variant="primary-icon-only"
                    @click="onSelect(data.item.id)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-project-show-add-user-modal-component',
    props: ['projectId'],
    data() {
        return {
            loading: false,
            fields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'type',
                    label: 'Type',
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
            items: null,
        };
    },

    methods: {
        onSelect(id) {
            this.$emit('user-added', id);
        },
        load() {
            this.loading = true;
            this.axios
                .get(this.routes.projectGetUsers(this.projectId) + '?query=&limit=10000&ascending=1&page=1&byColumn=0')
                .then(
                    (response) => {
                        this.items = response.data.data;
                        this.loading = false;
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
        },
        reload() {
            this.load();
        },
    },
    created() {
        this.load();
    },
};
</script>

<style scoped>
.group-admin-users-table >>> .table td * {
    white-space: normal;
}
</style>
